@if (hasServerErrors()) {
  <s-form-error-message>
    @for (severValidation of getServerErrors(); track severValidation) {
      <s-form-error-message>
        <s-form-error-message class="error-message">
          {{ severValidation }}
        </s-form-error-message>
      </s-form-error-message>
    }
  </s-form-error-message>
}

@if (schema && validationMessages) {
  <s-form-error-message>
    @for (validation of validationMessages; track validation) {
      <s-form-error-message>
        @if (
          (control?.hasError(validation.type) &&
            control?.hasError(validation.type)?.valueOf() === true &&
            (control.dirty || control.touched)) ||
          form.errors?.[validation.type]
        ) {
          <s-form-error-message class="error-message">
            {{ validation.message }}
          </s-form-error-message>
        }
      </s-form-error-message>
    }
  </s-form-error-message>
}
